/* import __COLOCATED_TEMPLATE__ from './resolve.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {};
  Element: HTMLElement;
}

const Resolve = templateOnlyComponent<Signature>();
export default Resolve;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::AnswerTerminal::Resolve': typeof Resolve;
  }
}
